import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css"; // Import Bootstrap CSS
import { useNav } from "../../components/NavContext";
import axios from "axios";

const OrderList = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const DOMAIN = process.env.REACT_APP_DOMAIN;
  const API_URL = process.env.REACT_APP_API_URL;
  axios.defaults.withCredentials = true;
  const { addLink } = useNav();

  useEffect(() => {
    addLink("اطبائنا", `${DOMAIN}control/doctor-list`);
    addLink("اضافة طبيب", `${DOMAIN}control/doctor-create`);
    addLink("الحجوزات", `${DOMAIN}control/order-list`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addLink]);

  useEffect(() => {
    document.title = "اطبائنا";
    const fetchData = async () => {

      try {
        const response = await axios.get(API_URL + "admin/orders/list", {}); // Replace with your API URL
        const data = await response.data;
        
        setItems(data);
        
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="container mt-4">
      <h2 className="mb-3">الحجوزات</h2>
      <table className="table table-striped table-bordered">
        <thead className="table-primary">
          <tr>
            <th>#</th>
            <th>رقم الطلب</th>
            <th>اسم المريض</th>
            <th>الطبيب</th>
            <th>رقم الهاتف</th>
            <th>يوم الاستشارة</th>
            <th>طريقة الدفع</th>
            <th>طريقة الحجز</th>
            <th>تاريخ الطلب</th>
          </tr>
        </thead>
        <tbody>
        {items.map((item, index) => (
            <tr key={item.order_id}>
              <td>{index + 1}</td>
              <td>{item.encrypted_id}</td>
              <td>{item?.full_name}</td>
              <td>{item?.doctor?.full_name}</td>
              <td>{item?.phone_number}</td>
              <td>{item?.order_date}</td>
              <td>{item?.payment_type}</td>
              <td>{item?.status}</td>
              <td>{item?.created_at}</td>
              
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default OrderList;